import { render, staticRenderFns } from "./ExpressDetail.vue?vue&type=template&id=6db7f390&scoped=true&"
import script from "./ExpressDetail.vue?vue&type=script&lang=js&"
export * from "./ExpressDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpressDetail.vue?vue&type=style&index=0&id=6db7f390&lang=scss&scoped=true&"
import style1 from "./ExpressDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db7f390",
  null
  
)

export default component.exports